import * as React from "react";
const SvgIoT = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.283 1.871v7.133H6.096v5.99H3.283v7.133h7.123v-7.133H7.594v-2.277c0-2.154.002-2.277.017-2.258.01.011.495.637 1.08 1.39l1.067 1.37h3.836v2.812h7.123V8.908h-7.123V11.721h-3.098l-1.053-1.352a219.807 219.807 0 0 1-1.052-1.36c0-.002.453-.005 1.007-.005h1.008V1.87h-3.56ZM4.781 3.38h4.127v4.119H4.781v-2.06Zm10.31 7.027h4.128v4.129l-2.06-.004-2.063-.002-.002-2.06zm-10.31 6.096h4.127v4.119H4.781v-2.06z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgIoT;
